import actions from "./actions";

const setUser = actions.setUser;
const updateProfile = actions.updateProfile;
const fetchOrderInProgress = actions.fetchOrderInProgress
const signOut = actions.signOut;
const verifyUser = actions.verifyUser;
const signUp = actions.signUp;
const signIn = actions.signIn;
const sendOtp = actions.sendOtp;
const resendOtp = actions.resendOtp;
const sendOtpViaEmail = actions.sendOtpViaEmail;
const resendOtpViaEmail = actions.resendOtpViaEmail;
const sendOtpForEmailReset = actions.sendOtpForEmailReset;
const resendOtpForEmailReset = actions.resendOtpForEmailReset;
const resetEmail = actions.resetEmail;
const updateMarketingConsent = actions.updateMarketingConsent;

export default {
  setUser,
  updateProfile,
  fetchOrderInProgress,
  signOut,
  verifyUser,
  signUp,
  signIn,
  sendOtp,
  resendOtp,
  sendOtpViaEmail,
  resendOtpViaEmail,
  sendOtpForEmailReset,
  resendOtpForEmailReset,
  resetEmail,
  updateMarketingConsent
};
